var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightsManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 23.4271H2.16667C1.52234 23.4271 1 22.9048 1 22.2604V1.26042C1 0.61609 1.52234 0.09375 2.16667 0.09375H20.8333C21.4777 0.09375 22 0.61609 22 1.26042V22.2604C22 22.9048 21.4777 23.4271 20.8333 23.4271ZM19.6667 21.0938V2.42708H3.33333V21.0938H19.6667ZM5.66667 4.76042H10.3333V9.42708H5.66667V4.76042ZM5.66667 11.7604H17.3333V14.0938H5.66667V11.7604ZM5.66667 16.4271H17.3333V18.7604H5.66667V16.4271ZM12.6667 5.92708H17.3333V8.26042H12.6667V5.92708Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightsManagement);
export default __webpack_public_path__ + "static/media/Rights_Management.572a6d4f469c5adb60a73790c0475e43.svg";
export { ForwardRef as ReactComponent };